<template>
  <div id="tryout-chooser">
    <button type="button" class="btn btn-success" v-on:click="newInitData()">Pilih</button>
    <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div id="modal" class="modal-container">
            <div class="modal-body">
              <!-- <app-datatable :items="rows" :headers="headers" :persistFilter="false" :hasAction="false" v-on:dblClicked="tryoutSelected($event)"></app-datatable> -->
              <app-datatable 
              :items="rows" 
              :headers="headers" 
							:has-action="false"
              :has-custom-pagination="true"
							:has-custom-search="true"
              v-on:dblClicked="tryoutSelected($event)"
              :custom-pagination-current-page="pagination.currentPage"
              :custom-pagination-per-page="pagination.perPage"
              :custom-pagination-total-pages="pagination.totalPages"
              :custom-pagination-sort-mode="pagination.sortMode"
              v-on:selected="selectedRow = $event" 
              v-on:changePage="pagination = {...pagination, currentPage: $event}"
							v-on:changeSortMode="pagination = {...pagination, sortMode: $event}"
							v-on:doSearch="search = {query: $event.value, by: headersKey[$event.key]}"
            />
            </div>
            <div class="modal-footer">
              <button class="btn btn-danger" v-on:click="showModal = false">Close</button>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <app-spinner v-if="isLoading"></app-spinner>
  </div>
</template>
<style>
.modal-body{
  overflow: auto;
}
</style>
<script>
import TryoutService from '@/services/tryout.js'
import DataTable from '@/components/plugins/DataTable'
import Spinner from '@/components/plugins/Spinner'

export default {
  name: 'tryout-chooser',
  components: {
    'app-datatable': DataTable,
    'app-spinner': Spinner
  }, 
  props: ['isInstant'],
  data: function() {
    return {
      isLoading: false,
      showModal: false,
      headers: ['Judul', 'Level', 'Durasi', 'Jml. Soal', 'Mata Pelajaran', 'Mulai', 'Berakhir'],
      headersKey: ['name', 'level', 'duration', 'itemCount', 'subtests', 'startDate', 'endDate'], // camel case for matching search with API
      rows: [],
      selectedRow: null,
			search: null,
      pagination: {
				perPage: 15,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			},
    }
  },
  watch: {
		pagination: function () {
			this.reloadDataAndOpenModal()
		},
	},
  methods: {
    tryoutSelected: function(tryout) {
      this.$emit('selected', tryout)
      this.showModal = false
    },
    newInitData: function () {
      this.search = null
			this.pagination = {
				perPage: 15,
				currentPage: 1,
				totalPages: 0,
				sortMode: 'desc',
			}
      this.reloadDataAndOpenModal()
    },
    reloadDataAndOpenModal: function() {
      this.isLoading = true
      var context = this
      var search = this.search
			var pagination = {
				perPage: this.pagination.perPage,
				currentPage: this.pagination.currentPage,
				sortMode: this.pagination.sortMode
			}
      TryoutService.getListPublishedTryout(pagination, search, function(result) {
        context.rows.splice(0, context.rows.length)
        if (result.success) {
          result.data.forEach(function(tryout) {
            if (context.isInstant && !tryout.is_repeated) return

            if (!tryout.group_id) {
              var subjects = ''
              var jmlSoal = 0
              tryout.subtests.forEach(function(subtest) {
                subjects += subtest.subject_name + ','
                jmlSoal += subtest.item_count
              })

              var start = tryout.start_date + ' ' + tryout.start_time
              var end = tryout.end_date + ' ' + tryout.end_time
              var row = {
                id: tryout.id,
                data: [tryout.name, tryout.level, tryout.duration, jmlSoal, subjects, start, end]
              }
              context.pagination.totalPages = tryout.page
              context.rows.push(row)
            }
          })

          context.isLoading = false
          context.showModal = true
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// TryoutChooser.vue?599ec69a